export default {
  'option.name.currency': '币种',
  'option.name.currencyName': '币种名称',
  'option.on': '开',
  'option.off': '关',
  'option.yes': '是',
  'option.name.time': '时间',
  'option.yesterday': '昨天',
  'option.today': '今天',
  'option.lastWeek': '上周',
  'option.thisWeek': '本周',
  'option.lastMonth': '上月',
  'option.thisMonth': '本月',
  // 'option.startTime.placeholder': '请选择 开始时间',
  // 'option.endTime.placeholder': '请选择 结束时间',
  'option.lowest': '最低',
  'option.highest': '最高',
  'option.noRefresh': '不刷新',
  'option.seconds': '秒',
  'option.enable': '启用',
  'option.maintenance': '维护',
  'option.pushType': '推送类型',
  'option.sendNow': '立即发送',
  'option.sendRegularly': '定时发送',
  'option.whetherToEnable': '是否启用',
  'option.turnOn': '开启',
  'option.closure': '关闭',
  'option.show': '显示',
  'option.dontShow': '不显示',
  'option.selectAll': '全选',
  'option.checkLeastOne': '至少选中一个选项',
  'option.displayTerminal': '显示终端',
  'option.deactivate': '停用',
  'option.open': '开启',
  'option.maintenanceSwitch': '维护开关',
  'option.applicableLevel': '适用层级',
  'option.webHall': 'Web大厅',
  'option.welcomePage': '迎宾页',
  'option.webAppDownloadSite': 'Web-APP下载站',
  'option.channelLink': '渠道链接',
  'option.beijingTime': '北京时间',
  'option.easternTime': '美东时间',
  'option.reviewDate': '审核日期',
  'option.paid': '已支付',
  'option.notPaid': '未支付',
  'option.underReview': '审核中',
  'option.rechargeRatio': '充值占比',
  'option.withdrawalRatio': '提现占比',
  'option.registrationProportion': '注册占比',
  'option.loginRatio': '登录占比',
  'option.loginRetention': '登录会员留存',
  'option.activeRetention': '活跃会员留存',
  'option.rechargeRate': '充值转化率',
  'option.withdrawalConversionRate': '提现转化率',
  'option.bettingRate': '投注转化率',
  'option.transferOut': '转出',
  'option.interest': '利息',
  'option.applyRejection': '拒绝后可申请',
  'option.longRejectionAgain': '拒绝后多久可申请',
  'option.alipayCode': '支付宝收款码',
  'option.weChatCode': '微信收款码',
  'option.cloudPaymentCode': '云闪付收款码',
};
